export default __webpack_public_path__ + "static/media/p2_main.151dd079.png";